import axios from "axios";
import { getFromLocalStorage, removeAllFromLocalStorage } from "../utils/Helpers";
import { base_api_url, default_api_timeout } from '../config.js'

const allInstanceUrl = [
	{
		'base_url': base_api_url,
		'instanceName': 'api',
		'timeout': default_api_timeout
	}
];

export let axiosInstances = {};

allInstanceUrl.map(item => {
	/*
	* create axios instance
	*/
	let instance = axios.create({
	  baseURL: `${item.base_url}`,
	  withCredentials: true,
	  timeout: `${item.timeout}`,
	  headers: {
	    "Content-Type": "application/json"
	  },
	});

	/*
	* handle request interceptor
	*/
	instance.interceptors.request.use(
		(config)=>handleConfig(config),	
		(error) => Promise.reject(error)
	);

	/*
	* handle response interceptor
	*/
	instance.interceptors.response.use(function (response) {
		return response;
	}, function (error) {
		if (error.response.status === 401) {
			logout();
		} else {
			return Promise.reject(error);	
		}
	});

	/*
	* assign correspondance instance
	*/
	axiosInstances[item.instanceName] = instance;
})

/*
* logput on getting status 401 from any api
*/
const logout = () => {
	removeAllFromLocalStorage();
	window.location.replace('/');
}

/**
 * handle config for get/post
 */
const handleConfig = (config) => {
	const token = getFromLocalStorage("token");
	if (token) {
		//config.headers['X-Cleartax-JWT-Auth-Token'] = 'eyJrSWQiOiJkZWZhdWx0IiwiYWxnIjoiUlMyNTYifQ.eyJpc3MiOiJzdHJpbmciLCJhdWQiOiJzdHJpbmciLCJleHAiOjE2Mjk3NjUwOTksInN1YiI6ImM3OGU3MDE0LTBjYmItNGE3Yy1iYzIxLTdjZjg0MThjZjVjYSJ9.DSOFn3u1gqNleR8NxWok3Uc3zgbZWGLA0KEAmUEYdIuUP3IYRg6VCpBW-zc4cN6I_iY1AI87Du2yG6flFNMvMImQIbMW7u69yDZjbmfjXpdp2uDyu8Zt5CxfMHsZbosNL-LWvYUrCUdYHr6a1DfoE3Q9NPbumYOUVH0cy1ftUbGWwiGz9qlrDjom0vLXSntfQUi6sNqRrfVqIeDdSxfND3Xxrt6-Q2bNihEz1a4x1lsdWS4fBI4ZDcjyXHnEsTTqhX8aRsX1VXwTRhZlxpZH_d52bvIHvYA57QAzeJ55sMmKWkTSD1sQ5Vi1dYjoEDVD1V4a-unVEykVYYgBUh_Emg'
		//config.headers['X-Cleartax-JWT-Auth-Token'] = 'eyJrSWQiOiJkZWZhdWx0IiwiYWxnIjoiUlMyNTYifQ.eyJpc3MiOiJzdHJpbmciLCJhdWQiOiJzdHJpbmciLCJleHAiOjE2MjY5MjY0MDksInN1YiI6IjVkYWRiZjlkLWQwMjgtNGM2YS1iMjhkLWM4NmE1YmViOGVhZCJ9.oO7oSseSbrbUtA65GxxWDu82DO6F1-I22HoaXUgJ1T5mDY0l8bNfxQ3SE6t9F6jNquC0JDanfi0h9UOfy0uDMIOLcUBwqwJk2Ot_ZV4H_Yuk2kDFxW5Ly9AzYgvRJ8R-P-v8QVAGpxc5ZdJL9hLWPAOJHSpb95TBvr_NhWPoBotgY9PkGwfmrIddftjPjVXtwWqD5nIM2mFGUxyJgEAz8bbhnn2lThxfHUio7BXvgREwj8EieVAf4goBRE7vMeiFiBOmulqAp4DfchDuVMbJ8wrKaCZBYnLAoc4g0hFR7JV0v4AXxCILyi_ixNtXnCbkyvzlISXcrIPSwLer_0NdQQ'
	}
	return config;
}
